import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg2 from '../assets/images/backgrounds/rentic_bg_element2.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import text from '../assets/images/backgrounds/rentic_bg_404.svg';
import { useNavigate } from "react-router-dom"
import { Helmet } from 'react-helmet-async';

export const Error404: React.FC = () => {

    const navigate = useNavigate();

    return (
        <div className="h-[100vh]">

            <Helmet>
                <title>Rentic - Viga</title>
            </Helmet>

            <div className="absolute top-0 left-0 flex justify-center items-center w-[100vw] h-[100vh]">
                <div className="shadow-main min-h-[100px] p-5 rounded-xl mb-[100px]">
                    <h4>
                        Kahjuks me ei leidnud Sinu otsitud lehte
                    </h4>

                    <div className="cursor-pointer p-2 hover:underline text-primary" onClick={() => { navigate("/") }}>Avalehele →</div>
                </div>

                <div className="max-h-full max-w-full">

                    <img className="absolute top-0 left-0 h-[80%] w-auto" src={bg1} alt="" />
                    <img className="absolute bottom-0 right-0 h-[70%] w-auto" src={bg2} alt="" />
                    <img className="absolute top-0 right-0 h-[20%] w-auto" src={bg3} alt="" />
                    <img className="absolute bottom-0 left-[50%] translate-x-[-50%] h-[50%] w-auto" src={text} alt="" />
                </div>
            </div></div>
    )
}